module.exports = __webpack_public_path__ + "static/media/amazing-amazonia.aa299c38.m4v";